import { Typography } from '@mui/material'
import React from 'react'
import { unix } from 'dayjs'
import { FlexCol } from '@/components/common/Columns'
import { Row } from '@/components/common/Rows'
import { CompleteSvg, PendingSvg } from '@/components/common/svgs'
import { TxStatus } from '@/api/dashboard/types'

const StatusIconMap = {
  [TxStatus.pending]: <PendingSvg />,
  [TxStatus.confirmed]: <CompleteSvg />,
}
const StatusLabelMap = {
  [TxStatus.pending]: 'Pending',
  [TxStatus.confirmed]: 'Confirmed',
}

const StatusCell = ({ status, time }: { status: TxStatus; time: string }) => {
  if (status === TxStatus.unknown) {
    return (
      <FlexCol sx={{ rowGap: 8 }}>
        <Typography sx={{ fontSize: '16px', fontWeight: 700 }}>No status yet</Typography>
        <Typography sx={{ fontSize: '16px', fontWeight: 400, opacity: 0.6 }}>--</Typography>
      </FlexCol>
    )
  }

  return (
    <FlexCol sx={{ rowGap: 8 }}>
      <Row columnGap={4}>
        {StatusIconMap[status]}
        <Typography
          sx={{ fontSize: '16px', fontWeight: 700, color: status === TxStatus.confirmed ? '#30C65A' : '#fff' }}
        >
          {StatusLabelMap[status]}
        </Typography>
      </Row>
      <Typography sx={{ fontSize: '16px', fontWeight: 400, opacity: 0.6 }}>
        {unix(Number(time)).format('YYYY.MM.DD HH:mm')}
      </Typography>
    </FlexCol>
  )
}

export default StatusCell
